

































































































import { Component, Vue } from 'vue-property-decorator';
import { 卸型 } from '@/type/wholesale/wholesale';

import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import moment from 'moment';
import { loginModule } from '@/store/authentication/login';

import { ValidationResult } from '@/type/validation/result';
import { 発注書出力条件型, 発注書出力条件バリデータ一覧, 発注書検索結果レコード型, 発注書検索結果型, 発注書検索条件型 } from '@/type/purchaseorder/report';

import { progress } from '@/script/progress';

import Datepicker from '@/components/datepicker/DatePicker.vue';
import Timepicker from '@/components/datepicker/TimePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import SenderSelector from '@/components/user/SenderSelector.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import WholesaleSelector from '@/components/wholesale/WholesaleSelector.vue';

@Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    Timepicker,
    SenderSelector,
    WholesaleSelector,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
  },
})

export default class PrintPurchaseOrder extends Vue {
  private アラートメッセージ: string | string[] | null = null;
  private 発注書出力条件: 発注書出力条件型 | null = null;

  private 発注書検索条件: 発注書検索条件型 | null = null;
  private 発注書検索結果リスト: 発注書検索結果レコード型[] = [];

  private 検索条件バリデーション結果: ValidationResult = new ValidationResult(発注書出力条件バリデータ一覧);

  private created(): void {
    this.initialize();
  }

  private initialize(): void {
    this.発注書出力条件 = {
      発注伝票番号リスト: null,
    };

    this.発注書検索条件 = {
      確定送信者コード: null,
      卸コード: null,
      発注日開始日付: moment().toDate(),
      発注日開始時刻: null,
      発注日終了日付: moment().toDate(),
      発注日終了時刻: null,
    };

    this.発注書検索結果リスト = [];

    if (!loginModule.管理者である) {
      this.発注書検索条件.確定送信者コード = loginModule.利用者コードを取得する;
    }
  }

  private beforeUpdate(): void {
    this.検索条件バリデーション結果.validate(this.発注書検索条件);
  }

  private 入力エラー判定(項目名: string): boolean {
    return this.検索条件バリデーション結果.hasError(項目名);
  }

  private 印刷ダイアログを開く(): void {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.検索条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    this.ダイアログを開く('印刷ダイアログ');
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private APIアラートダイアログを開く(data: any) {
      this.アラートメッセージ = [data.message];
      if (data.errors !== null && data.errors !== undefined) {
        for (const エラー of data.errors) {
          this.アラートメッセージ = this.アラートメッセージ.concat(['・' + エラー]);
        }
      }
      this.$modal.show('アラート');
  }

  private 検索条件をクリアする(): void {
    this.initialize();
    this.ダイアログを閉じる('クリアダイアログ');
  }

  private 全選択する() {
    this.選択を全て変更する(true);
  }

  private 全解除する() {
    this.選択を全て変更する(false);
  }

  private 選択を全て変更する(選択: boolean) {
    for (const 発注書検索結果 of this.発注書検索結果リスト) {
      発注書検索結果.選択 = 選択;
    }
  }

  private async 発注書帳票出力ハンドラ(): Promise<void> {
    await progress(this.発注書帳票出力をする);
  }

  private async 検索するハンドラ(): Promise<void> {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.検索条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    await progress(this.検索する);
  }

  private async 検索する(): Promise<void> {
    if (!this.発注書検索条件) {
      return;
    }
    this.発注書検索結果リスト = [];
    await api.発注書を検索する(this.発注書検索条件)
      .then((response: 発注書検索結果型) => {
        this.発注書検索結果リスト = response.発注書検索結果リスト
          .map((発注書検索結果レコード: 発注書検索結果レコード型) => {
            return {
              選択: false,
              発注伝票番号: 発注書検索結果レコード.発注伝票番号,
              発注日: 発注書検索結果レコード.発注日,
              発注確定時刻: 発注書検索結果レコード.発注確定時刻,
              納品指定日: 発注書検索結果レコード.納品指定日,
              卸コード: 発注書検索結果レコード.卸コード,
              卸名: 発注書検索結果レコード.卸名,
              確定送信者コード: 発注書検索結果レコード.確定送信者コード,
            };
          });
        if (this.発注書検索結果リスト.length === 0) {
          this.アラートメッセージ = '該当の発注書は存在しません';
          this.$modal.show('アラート');
          return;
        }
        if (response.アラートメッセージ) {
          this.アラートメッセージ = response.アラートメッセージ;
          this.$modal.show('アラート');
        }
      })
      .catch((error: any) => {
        this.APIアラートダイアログを開く(error.data);
      });
  }

  private async 発注書帳票出力をする(): Promise<void> {
    const 発注伝票番号リスト: number[] = this.発注書検索結果リスト
      .filter((発注書検索結果レコード: 発注書検索結果レコード型) => {
        return 発注書検索結果レコード.選択 === true;
      })
      .map((発注書検索結果レコード: 発注書検索結果レコード型) => {
        return 発注書検索結果レコード.発注伝票番号;
      });
    this.発注書出力条件 = { 発注伝票番号リスト };
    if (!this.発注書出力条件) { return; }
    const ファイル名: string = '発注書_' + moment().format('YYYYMMDDhhmmss') + '.pdf';
    download.対象の発注書帳票を出力する(ファイル名, this.発注書出力条件)
        .catch((error: any) => {
          this.APIアラートダイアログを開く(error.data);
        });
    this.ダイアログを閉じる('印刷ダイアログ');
  }
}
